<!--充值记录列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">钱包记录</span>
      </div>
    </div>
    <div class="filter-box">
      <div class="item_box">
        <span class="subtitle">用户ID:</span>
        <Input
          v-model="page.account"
          placeholder="请输入用户ID"
          style="width: 150px; margin: 0 10px"
        >
        </Input>
        <span class="subtitle">订单号:</span>
        <Input
          v-model="page.order_no"
          placeholder="请输入订单号"
          style="width: 150px; margin: 0 10px"
        >
        </Input>
        <span class="subtitle">记录类型:</span>
        <Select
          v-model="page.select_type"
          style="width: 100px; text-align: center; margin: 0 10px"
        >
          <Option :value="-1">全部</Option>
          <!-- <Option :value="0">用户充值</Option> -->
          <!-- <Option :value="1">订单消费</Option> -->
          <!-- <Option :value="2">退款</Option> -->
          <Option v-for="(item, index) in logTypes" :key="index" :value="item.type">{{
            item.label
          }}</Option>
        </Select>
        <span class="subtitle">记录时间:</span>
        <DatePicker
          :value="page.start"
          format="yyyy-MM-dd"
          type="date"
          placement="bottom-end"
          placeholder="开始日期"
          style="width: 130px; margin: 0 5px"
          :editable="false"
          @on-change="(value) => (page.start = value)"
        ></DatePicker>
        <span>至</span>
        <DatePicker
          :value="page.end"
          format="yyyy-MM-dd"
          type="date"
          placeholder="结束日期"
          style="width: 130px; margin: 0 5px"
          :editable="false"
          @on-change="(value) => (page.end = value)"
        ></DatePicker>
      </div>
      <div class="bottom">
        <Button
          type="primary"
          style="margin: 0 0 0 5px"
          @click="tableLoad ? null : getData()"
          >查询</Button
        >
        <Button style="margin: 0 0 0 5px" @click="reset">重置</Button>
        <Poptip title="导出Excel" placement="right" trigger="hover">
          <Button style="margin: 0 5px">导出Excel</Button>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
      </div>
    </div>
    <div>
      <Table
        :columns="columns"
        :data="data"
        :loading="tableLoad"
        @on-sort-change="tableSort"
      />
    </div>
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        show-elevator
        show-sizer
        show-total
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
import { verifyDate, monDiff } from '@/libs/util'

const logTypes = [
  {
    type: 0,
    label: '用户充值'
  },
  {
    type: 1,
    label: '打印消费'
  },
  {
    type: 2,
    label: '异常退款'
  },
  {
    type: 3,
    label: '复印消费'
  },
  {
    type: 4,
    label: '扫描消费'
  },
  {
    type: 5,
    label: '冲印消费'
  },
  {
    type: 6,
    label: '平台充值'
  },
  {
    type: 7,
    label: '用户充值'
  },
  {
    type: 8,
    label: '员工配额'
  },
  {
    type: 9,
    label: '人工退款'
  },
  {
    type: 10,
    label: '钱包清零'
  }
]
export default {
  data () {
    return {
      logTypes,
      page: {
        p: 0,
        l: 10,
        select_type: -1,
        type: [],
        start: '',
        end: '',
        date: [],
        account: '',
        order_no: '',
        key: 'l.id',
        order: 'desc'
      },
      dateOption: {
        disabledDate (date) {
          return date && date.valueOf() > Date.now()
        }
      },
      columns: [
        // {
        //   title: "编号",
        //   width: 100,
        //   key: "id",
        //   sortable: "custom",
        //   _sortKey: "recharge.id",
        // },
        // {
        //   title: "用户编号",
        //   width: 105,
        //   key: "user_id",
        //   sortable: "custom",
        //   _sortKey: "recharge.user_id",
        // },
        {
          title: '记录时间',
          key: 'create_time',
          width: 150,
          render: (h, data) => {
            return h('span', this.$moment(new Date(data.row.create_time)))
          },
          sortable: 'custom',
          _sortKey: 'recharge.note'
        },
        { title: 'ID账号', width: 120, key: 'account' },
        { title: '手机号', width: 120, key: 'tel' },
        { title: '昵称', width: 160, key: 'name' },
        { title: '订单号', key: 'order_no' },
        { title: '金额', width: 80, key: 'money' },
        {
          title: '类型',
          width: 100,
          key: 'type',
          render: (h, data) => {
            let label = ''
            logTypes.map((item) => {
              if (item.type == data.row.type) {
                label = item.label
              }
            })
            return h('span', {}, label)
            /* switch (data.row.type) {
              // 0用户充值 1订单消费 2退款
              case 0:
                return h("span", {}, "用户充值");
                break;
              case 1:
                return h("span", {}, "订单消费 ");
                break;
              case 2:
                return h("span", {}, "退款");
                break;
            } */
          },
          sortable: 'custom',
          _sortKey: 'recharge.type'
        },
        { title: '日志', key: 'log' }
      ],
      data: [],
      total: 0,
      tableLoad: false
    }
  },
  methods: {
    tableSort (col) {
      this.page.key = col.column._sortKey
      this.page.order = col.order
      this.getData()
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    reset () {
      this.page = {
        p: 0,
        l: 10,
        select_type: -1,
        type: [],
        start: '',
        end: '',
        date: [],
        account: '',
        order_no: '',
        key: 'l.id',
        order: 'desc'
      }
      this.setDate()
      this.getData()
    },
    setDate () {
      /*  let temp = new Date();
      temp.setDate(1);
      this.page.date = [
        this.$moment(temp, "YYYY-MM-DD"),
        this.$moment(new Date(), "YYYY-MM-DD"),
      ];
      this.page.start = this.page.date[0];
      this.page.end = this.page.date[1]; */
    },
    getData () {
      if (this.page.start && this.page.end && verifyDate(this.page.start, this.page.end)) {
        this.$Message.error('开始时间不能大于结束时间')
        return
      }
      /*  if (monDiff(this.page.start, this.page.end) > 12) {
        //如果时间跨度超过一年就提示
        this.$Message.error("筛选的时间跨度不能超过1年");
        return;
      } */
      this.tableLoad = true
      this.page.date = [this.page.start, this.page.end]
      this.ConsumptionRecord(this.page).then((res) => {
        this.data = res.data
        this.total = res.total
        this.tableLoad = false
      })
    },
    exportData (is_all) {
      console.log('全部', is_all)
      let params = {
        title: [],
        key: [],
        autoWidth: true,
        filename: '钱包记录'
      }
      this.columns.map((item) => {
        params.title.push(item.title)
        params.key.push(item.key)
      })
      if (is_all) {
        let p = this.page
        p.l = 100000
        p.p = 0
        this.ConsumptionRecord(p).then((res) => {
          res.data.map((item) => {
            item.type =
              item.type === 0
                ? '用户充值'
                : item.type === 1
                  ? '订单消费'
                  : item.type == 2
                    ? '退款'
                    : ''
            item.create_time = this.$moment(new Date(item.create_time))
          })
          params.data = res.data
          excel.export_array_to_excel(params)
        })
      } else {
        this.ConsumptionRecord(this.page).then((res) => {
          res.data.map((item) => {
            item.type =
              item.type === 0
                ? '用户充值'
                : item.type === 1
                  ? '订单消费'
                  : item.type == 2
                    ? '退款'
                    : ''
            item.create_time = this.$moment(new Date(item.create_time))
          })
          params.data = res.data
          excel.export_array_to_excel(params)
        })
      }
    },
    ...mapActions(['ConsumptionRecord'])
  },
  mounted () {
    this.setDate()
    this.getData()
  },
  computed: mapGetters({}),
  watch: {
    'page.select_type' (type, o) {
      console.log('类型', type)
      switch (type) {
        case -1:
          this.page.type = []
          break
        case 0:
          this.page.type = [0, 6, 7, 8]
          break
        case 1:
          this.page.type = [1, 3, 4, 5]
          break
        case 2:
          this.page.type = [2, 9]
          break
      }
      this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
